import React, { useEffect, useState } from "react";
import {
  HEADER_DOWN_ARROW,
  USER_ALARM_ICON,
  USER_BELL_ICON,
  USER_PROFILE_IMG,
  USER_TOP_PMBI_LOGO,
} from "../../../../utils/app-image-contant";
import { Link } from "react-router-dom";
import { clearAccessTokenReducer } from "../../../../hooks/redux/slice/access-token";
import { useDispatch, useSelector } from "react-redux";
import { clearLoggedUserReducer } from "../../../../hooks/redux/slice/logged-user";
import {
  getNotification,
  seenNotification,
} from "../../../../hooks/services/api-services";
import { API_RESPONSE } from "../../../../utils/app-constants";
import { toastEmitter } from "../../../../utils/utilities";
import WebModal from "./Modal/webModal";
import moment from "moment";

function
  Topbar() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { value } = useSelector((state) => state?.loggedUser);
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [isProfile, setIsProfile] = useState(false);
  const [notificationData, setnotificationData] = useState([]);
  const notificationPayload = {
    userId: value?.userId,
    status: null,
    pageIndex: 0,
    pageSize: 1000,
  };


  useEffect(() => {
    document.querySelector(".side-header-toggle").onclick = function () {
      const element = document.querySelector("#side-bar-show");
      if (element.getAttribute("class") === "sidebar") {
        element.setAttribute("class", "sidebar active_sidebar");
      } else {
        element.setAttribute("class", "sidebar");
      }

      const screen = document.querySelector("#topbar-content");
      if (screen.getAttribute("class") === "container-fluid topSection") {
        screen.setAttribute("class", "container-fluid topSection full-view");
      } else {
        screen.setAttribute("class", "container-fluid topSection");
      }
      const mainSection = document.querySelector("#main-layout-section");
      if (mainSection.getAttribute('class') === "main_content dashboard_part large_header_bg") {
        mainSection.setAttribute("class", "main_content dashboard_part large_header_bg no-padding")
      } else {
        mainSection.setAttribute("class", "main_content dashboard_part large_header_bg")
      }
      const maininnerSection = document.querySelector("#main-inner-layout-section");
      if (maininnerSection.getAttribute('class') === "main_content_iner overly_inner") {
        maininnerSection.setAttribute("class", "main_content_iner overly_inner no-top-space")
      } else {
        maininnerSection.setAttribute("class", "main_content_iner overly_inner")
      }
    };
    document.querySelector(".ti-close").onclick = function () {
      const element2 = document.querySelector("#side-bar-show");
      if (element2.getAttribute("class") === "sidebar") {
        element2.setAttribute("class", "sidebar active_sidebar");
      } else {
        element2.setAttribute("class", "sidebar");
      }
    };

  }, []);

  // useEffect(() => {
  //   document.querySelector("#listMenu").onclick = function () {
  //     const listElement = document.querySelector("#side-bar-show");
  //     if (listElement.getAttribute("class") === "sidebar active_sidebar") {
  //       listElement.setAttribute("class", "sidebar");
  //     } else {
  //       listElement.setAttribute("class", "sidebar active_sidebar");
  //     }
  //   };
  // }, [])


  const handleLogout = () => [
    dispatch(clearAccessTokenReducer()),
    dispatch(clearLoggedUserReducer()),
    localStorage.removeItem('nMenuData')
  ];

  const currentDate = new Date();
  let hours = currentDate.getHours();
  const meridiem = hours >= 12 ? "PM" : "AM";
  const minutes = currentDate.getMinutes().toString().padStart(2, '0');
  const formattedTime = `${hours}:${minutes} ${meridiem}`;


  useEffect(() => {
    notification();
  }, []);

  const notification = async () => {
    setLoading(true);
    try {
      const response = await getNotification(notificationPayload);
      if (response?.data?.responseCode == 200) {
        setLoading(false);
        setnotificationData(response?.data?.data?.webNotificationResponseList);
      } else {
        setLoading(false);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  const viewNotification = async (id, status) => {
    setLoading(true);
    try {
      const response = await seenNotification(id, status);
      if (response?.data?.responseCode == 200) {
        notification();
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  const handleNotification = (data) => {
    viewNotification(data?.id, 0);
  };


  return (
    <>
      <div className="container-fluid topSection g-0 px-3 px-md-0" id="topbar-content">
        <div className="row">
          <div className="col-lg-12 p-0 ">
            <div className="header_iner d-flex justify-content-end align-items-center">
              <div
                type="button"
                className="sidebar_icon side-header-toggle"
              >
                <i className="ti-menu d-flex justify-content-center align-items-center">
                  <div className="header-logo-img d-lg-none">
                    <img src={USER_TOP_PMBI_LOGO} alt="" />
                  </div>
                </i>
              </div>

              <div className="header_right d-flex align-items-center janaushadhi-web">
                <div className="header_notification_warp d-flex align-items-center ">
                  <li>
                    <a className="bell_notification_clicker cursor-pointer">
                      <img src={USER_BELL_ICON} alt />
                      {notificationData?.filter((item) => item?.status === 1)
                        ?.length > 0 && (
                          <>
                            <span>
                              {notificationData?.filter(
                                (item) => item?.status === 1
                              )?.length || 0}
                            </span>
                          </>
                        )}
                    </a>

                    <div className="Menu_NOtification_Wrap">
                      <div className="notification_Header">
                        <h4>Notifications</h4>
                      </div>
                      {notificationData?.length === 0 ? (
                        <>
                          <div className="Notification_body d-flex justify-content-center align-items-center">
                            <p>Record not found</p>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="Notification_body">
                            {notificationData?.map((item) => (
                              <>
                                <div
                                  className={`single_notify d-flex align-items-center ${item?.status === 0
                                    ? "notify-seen"
                                    : "notify-unseen"
                                    }`}
                                >

                                  <div className="notify_content">
                                    <a
                                      type="button"
                                      onClick={() => handleNotification(item)}
                                    >
                                      <p>
                                        <span className="fw-bold">
                                          {item?.applicationId}
                                        </span>{" "}
                                        {item?.description}
                                        <br />
                                        <span>{moment(item?.createdDate)?.format(
                                          "ddd, MMM Do YYYY,hh:mmA"
                                        )}</span>
                                      </p>
                                    </a>
                                  </div>
                                </div>
                              </>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  </li>
                  <li className="d-flex justify-content-center align-items-center">
                    <a className="CHATBOX_open">
                      <img src={USER_ALARM_ICON} alt="alarm" />
                    </a>
                    <p className="spartan-text text-white mb-0 ms-2">
                      {formattedTime}
                    </p>
                  </li>
                </div>
                <div className="profile_info d-flex justify-content-center align-items-center user-profile-style">
                  <img src={value?.profileImage !== null ? value?.profileImage : USER_PROFILE_IMG} alt="profile" />
                  <p className="spartan-text text-white mb-0 ms-2">
                    Hello!{" "}{value?.name}
                  </p>
                </div>
                <div className="user-profile-info profile_info cursor-pointer">
                  <img
                    src={HEADER_DOWN_ARROW}
                    alt="down-arrow-icon "
                    width="10px"
                  />
                  <div className="profile_info_iner">
                    <div className="profile_info_details website">
                      <Link
                        to=""
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() => {
                          setIsProfile(true);
                          setIsChangePassword(false);
                        }}
                      >
                        MY PROFILE{" "}
                      </Link>
                      <Link
                        to=""
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() => {
                          setIsProfile(false);
                          setIsChangePassword(true);
                        }}
                      >
                        CHANGE PASSWORD
                      </Link>
                      <Link
                        to=""
                        onClick={handleLogout}
                        className="text-danger"
                      >
                        LOG OUT
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <WebModal isProfile={isProfile} isChangePassword={isChangePassword} />
    </>
  );
}

export default Topbar;
